import { render } from "./CampaignShow.vue?vue&type=template&id=230ec609&scoped=true"
import script from "./CampaignShow.vue?vue&type=script&lang=js"
export * from "./CampaignShow.vue?vue&type=script&lang=js"

import "./CampaignShow.vue?vue&type=style&index=0&id=230ec609&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230ec609"]])

export default __exports__